import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import withRouter from '.././components/withRouter';

//import Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

//import actions
import {
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility
} from "../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

// Toast / Notifications
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useProfile } from '../hooks/UserHooks';

// Crisp chatbot type declarations
// declare global {
//     interface Window {
//         $crisp: any[];
//         CRISP_WEBSITE_ID: string;
//     }
// }

const Layout = (props: any) => {
    const { userProfile } = useProfile();
    const [headerClass, setHeaderClass] = useState("");
    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutType: layout.layoutType,
            leftSidebarType: layout.leftSidebarType,
            layoutModeType: layout.layoutModeType,
            layoutWidthType: layout.layoutWidthType,
            layoutPositionType: layout.layoutPositionType,
            topbarThemeType: layout.topbarThemeType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            leftSidebarViewType: layout.leftSidebarViewType,
            leftSidebarImageType: layout.leftSidebarImageType,
            preloader: layout.preloader,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
        })
    );
    // Inside your component
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);

    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        dispatch]);
    /*
    call dark/light mode
    */
    const onChangeLayoutMode = (value: any) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };

    // class add remove in header 
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });

    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    useEffect(() => {
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        if (sidebarVisibilitytype === 'show') {
            humberIcon.classList.remove('open');
        } else {
            humberIcon && humberIcon.classList.add('open');
        }
    }, [sidebarVisibilitytype, layoutType]);

    // useEffect(() => {
    //     window.$crisp = [];
    //     window.CRISP_WEBSITE_ID = "dd7d420f-605c-4682-960d-33c629332d32";
    //     var d = document;
    //     var s = d.createElement("script");
    //     s.src = "https://client.crisp.chat/l.js";
    //     s.async = true;
    //     d.getElementsByTagName("head")[0].appendChild(s);
    // }, []);

    // useEffect(() => {
    //     if (userProfile && !userProfile.impersonatedUser) {
    //         // Adicionar dados do usuário logado
    //         window.$crisp.push(["set", "user:email", [userProfile.email]]);
    //         window.$crisp.push(["set", "user:nickname", [userProfile.name]]);
    //         window.$crisp.push(["set", "session:data", [{
    //             user_id: userProfile.id,
    //             publisher_id: userProfile.publisher?.id || undefined,
    //             agency_id: userProfile.agency?.id || undefined,
    //             advertiser_id: userProfile.advertiser?.id || undefined,
    //             ad_network_id: userProfile.adNetwork?.id || undefined,
    //         }]]);
    //     }
    // }, [userProfile]);

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header
                    headerClass={headerClass}
                    layoutModeType={layoutModeType}
                    onChangeLayoutMode={onChangeLayoutMode} />
                <Sidebar
                    layoutType={layoutType}
                />
                <div className="main-content">
                    {props.children}
                    <Footer />
                </div>
            </div>
            <ToastContainer
                autoClose={3000}
                position={"top-right"}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnFocusLoss={true}
                draggable={false}
                theme={"light"}
            />
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);